import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import SearchSelectFields from 'src/components/widgets/search-select-fields';
import { servicesApi } from 'src/api/lazy-api';

export const DropdownServices = ({ formik, types }) => {
  // Quick filter list
  const isFetchingData = useRef(false);
  const [services, setServices] = useState([]); // Default empty array
  const [loading, setLoading] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading('Loading...');
      try {
        const fetchedServices = await servicesApi.getItems(types);
        setServices(fetchedServices);
      } finally {
        setLoading('');
        isFetchingData.current = false; // Reset after async function completes
      }
    };
    
    if (!isFetchingData.current) {
      isFetchingData.current = true;
      fetchData();
    }
  }, []); // Empty dependency array → Runs once when component mounts

  const handleChanged = (selectedValues) => {
    formik.setFieldValue('serviceField', selectedValues);
  };

  return (
    <SearchSelectFields
      label="Mục bảo dưỡng"
      name="serviceField"
      options={services}
      defaultValue={formik.values?.defaultService}
      onSelected={handleChanged}
      formik={formik}
      hintValue={loading}
    />
  );
};

DropdownServices.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default DropdownServices;
